// throttle function, enforces a minimum time interval
// https://stackoverflow.com/questions/32395988/highlight-menu-item-when-scrolling-down-to-section
function throttle(fn, interval) {
    var lastCall, timeoutId;
    return function () {
        var now = new Date().getTime();
        if (lastCall && now < (lastCall + interval)) {
            // if we are inside the interval we wait
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                lastCall = now;
                fn.call();
            }, interval - (now - lastCall) );
        } else {
            // otherwise, we directly call the function
            lastCall = now;
            fn.call();
        }
    };
}

// Get the correct width of the current viewport
// https://stackoverflow.com/questions/18546067/why-is-the-window-width-smaller-than-the-viewport-width-set-in-media-queries
function viewport() {
    var e = window,
        a = 'inner';

    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return {
        width : e[a + 'Width'], height : e[a + 'Height'],
    };
}

module.exports = {
    throttle: throttle,
    viewport: viewport,
};
